import { ErrorNotFound } from "./error/ErrorPage";
import { logError } from "../api/logError";
import { createBrowserRouter, RouterProvider } from "react-router";
import { SelectOrganisationPage } from "./SelectOrganisationPage";
import { extractRoutesFromSidebarMenuItems, OrganisationSelectedProviders } from "./OrganisationSelected";
import * as downloadReportsPage from "../pages/DownloadReportsPage/route";
import { ensureUserInfo } from "../api/userInfo";
import { trustRoute } from "../trust/Trust";
import { assistantInviteRoute } from "../pages/AssistantPage/invite/AssistantInvite";
import { Providers } from "./Providers";

const Healthy = () => <div>Healthy</div>;
const NotFound = () => <ErrorNotFound isAuthenticated={true} />;

const router = createBrowserRouter([
  { path: "/health", Component: Healthy },
  trustRoute,
  assistantInviteRoute,
  {
    path: "/",
    Component: Providers,
    loader: () => void ensureUserInfo(),
    children: [
      { index: true, Component: SelectOrganisationPage },
      {
        path: ":organisationSlug",
        Component: OrganisationSelectedProviders,
        children: [
          ...extractRoutesFromSidebarMenuItems(),
          downloadReportsPage.route,
          { path: "*", Component: NotFound },
        ],
      },
    ],
  },
]);

export const Router = () => {
  return <RouterProvider router={router} onError={error => logError(error, { loggedFrom: "RouterProvider" })} />;
};
